import { cn } from '~/lib/cn';

export interface InlineTab {
    key: string;
    label: string;
    icon?: React.ReactNode;
    show?: boolean;
    /** Greys the tab out while keeping it clickable, for views that rarely apply here. */
    muted?: boolean;
}

interface Props {
    tabs: InlineTab[];
    activeTab: string;
    onChange: (key: string) => void;
    className?: string;
}

// Generic horizontal tab bar with underline indicator. Scrollable on small screens.
const InlineTabBar = ({ tabs, activeTab, onChange, className }: Props) => (
    <div
        className={cn(
            'tw-flex tw-flex-wrap tw-border-0 tw-border-b tw-border-solid tw-border-accents-2',
            className
        )}
    >
        {tabs
            .filter((t) => t.show !== false)
            .map((tab) => (
                <button
                    key={tab.key}
                    type="button"
                    onClick={() => onChange(tab.key)}
                    className={cn(
                        'tw-cursor-pointer tw-whitespace-nowrap tw-border-0 tw-border-b-2 tw-border-solid tw-bg-transparent tw-px-4 tw-py-2.5 tw-text-sm tw-font-medium tw-transition-colors',
                        tab.key === activeTab
                            ? 'tw-border-success tw-text-success'
                            : 'tw-border-transparent tw-text-accents-6 hover:tw-text-accents-8',
                        tab.muted && tab.key !== activeTab && 'tw-opacity-50'
                    )}
                >
                    {tab.icon && <span className="tw-mr-1.5">{tab.icon}</span>}
                    {tab.label}
                </button>
            ))}
    </div>
);

export default InlineTabBar;
